define('app/views/city_page_view',['app/setup'], function(takhfifan) {

  takhfifan.CityPageView = Backbone.View.extend({

    initialize: function() {
      this.setCity();
    },

    setCity: function() {
      var cityPath = this.$el.data('cityPath');

      $.cookie('city', cityPath, {
        path: '/',
        domain: '.' + document.domain
      });
    }

  });

  var $cp = $('#tkh-city-page');

  if ($cp.length > 0) {
    new takhfifan.CityPageView({el: $cp});
  };

});

